module.exports = __webpack_public_path__ + "img/MRC_Android.1dc70413.png";